import { ErrorMessage } from "formik";
import { useEffect, useState } from "react";
import AsyncSelect from "react-select/async";

const CustomSelectAsync = ({
  field,
  form: { touched, errors, setFieldValue },
  label,
  isMulti,
  required,
  placeholder,
  onChange,
  options,
  loadOptionsFn,
  isClearable = true,
  noMarginBottom,
  menuStyles,
  labelFieldName,
  ...props
}) => {
  let values = [];
  let titleContent = props?.title;

  const [selectedValue, setSelectedValue] = useState(null);

  useEffect(() => {
    if (field?.value) {
      values = [
        {
          label: props?.title,
          value: field?.value,
        },
      ];
      setSelectedValue(values);
    } else {
      setSelectedValue(null);
    }
  }, [field?.value]);

  return (
    <div
      className={`${noMarginBottom == true ? "" : "mb-2"}`}
      title={titleContent} //to display selected option text as tooltip
    >
      {label && (
        <label className="mb-1">
          {label} {required && <span className="text-danger">*</span>}
        </label>
      )}
      <AsyncSelect
        // {...field}
        {...props}
        cacheOptions
        defaultOptions
        loadOptions={loadOptionsFn}
        value={selectedValue}
        placeholder={placeholder}
        isClearable={isClearable}
        // classNamePrefix={`select2 select-${field.name}`}
        classNamePrefix={`select2 select2-`}
        onChange={(event) => {
          if (onChange) {
            onChange(event);
          } else {
            if (isMulti === true) {
              // setFieldValue(field.name, event ?? [])
              setFieldValue(field.name, event ?? null);
            } else {
              // setFieldValue(field.name, event?.value ?? null)
              setFieldValue(field.name, event?.value ?? "");
              setFieldValue(labelFieldName, event?.label ?? "");
            }
          }
        }}
        className={`${
          !!touched[field.name] && !!errors[field.name] && "border-danger"
        }`}
        isMulti={isMulti === true}
        styles={{
          menu: (css) => ({
            ...css,
            width: "max-content", //open menu options in full width
            minWidth: "100%", //open menu options in 100% when not required full width
            zIndex: 2,
            ...menuStyles, //when menu option going off screen pass {position: "absolute", right: 0}
          }),
          option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected
              ? "#18a594"
              : state.isFocused
              ? "rgb(222, 235, 255)"
              : "inherit",
            "&:hover": {
              backgroundColor: state.isSelected
                ? "#18a594"
                : "rgb(222, 235, 255)",
            },
          }),
          control: (css) => ({
            ...css,
            minWidth: "100%",
            minHeight: "2rem",
            padding: "0rem 0.4rem",
            fontSize: "0.86563rem",
            borderRadius: "0.3rem",
            height: "calc(1.5em + 0.5rem + 6px)",
            // borderColor: "#84d8e2",
            boxShadow: "#c93636",
            // "&:hover": {
            //   borderColor: "#84d8e2",
            // },
            "&:focus-within": {
              borderColor: "#18a594",
            },
          }),
          container: (css) => ({
            ...css,
            padding: "0",
            fontSize: "0.86563rem",
          }),
          valueContainer: (css) => ({
            ...css,
            padding: "0",
          }),
          dropdownIndicator: (css) => ({
            ...css,
            padding: "0",
            width: "16px",
            marginLeft: "1px",
          }),
          clearIndicator: (css) => ({
            ...css,
            padding: "0",
            width: "16px",
            marginRight: "1px",
          }),
          indicatorsContainer: (css) => ({
            ...css,
            paddingRight: "0",
          }),
          loadingIndicator: (css) => ({
            ...css,
            display: "none",
          }),
        }}
      />
      <ErrorMessage
        name={field.name}
        component="div"
        className="invalid-feedback animated fadeInUp"
        style={{ display: "block" }}
      />
    </div>
  );
};

export default CustomSelectAsync;
